module.exports = __webpack_public_path__ + "static/img/sqsy.d4b925b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/sqsy.jpg
// module id = utxS
// module chunks = 3